import _1 from "./1.png";
import _2 from "./2.png";
import _3 from "./3.png";
import _4 from "./4.png";
import _5 from "./5.png";
import _6 from "./6.png";
import _7 from "./7.png";
import _8 from "./8.png";
import _9 from "./9.png";
import _10 from "./10.png";
import _11 from "./11.png";
import _12 from "./12.png";
import _13 from "./13.png";
import _14 from "./14.png";
import _15 from "./15.png";
import _16 from "./16.png";
import _17 from "./17.png";
import _18 from "./18.png";
import _19 from "./19.png";

export const friendUrls = [
  _1,
  _2,
  _3,
  _4,
  _5,
  _6,
  _7,
  _8,
  _9,
  _10,
  _11,
  _12,
  _13,
  _14,
  _15,
  _16,
  _17,
  _18,
  _19,
];
